var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMikeIcnCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1865C1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3554_11719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4265 25.8391C23.3716 26.4361 22.2064 26.8124 21.0015 26.9451V31.0001H19.0015V26.9451C16.9727 26.7176 15.0813 25.8075 13.6377 24.3639C12.1941 22.9203 11.2839 21.0289 11.0565 19.0001H13.0715C13.2274 20.0795 13.6333 21.1075 14.2568 22.0023C14.8804 22.8971 15.7043 23.6339 16.663 24.1539C17.6216 24.6739 18.6885 24.9628 19.7785 24.9976C20.8686 25.0323 21.9517 24.812 22.9415 24.3541L21.3905 22.8041C20.6457 23.0194 19.861 23.0587 19.0985 22.9186C18.3359 22.7786 17.6163 22.4631 16.9966 21.9972C16.3769 21.5312 15.8741 20.9275 15.5278 20.2338C15.1816 19.5401 15.0014 18.7754 15.0015 18.0001V16.4141L9.39453 10.8081L10.8095 9.39305L30.6085 29.1931L29.1935 30.6071L24.4265 25.8391ZM17.0345 18.4471L19.5545 20.9671C18.9204 20.8713 18.3336 20.5749 17.8801 20.1215C17.4266 19.668 17.1303 19.0812 17.0345 18.4471ZM27.3765 23.1601L25.9335 21.7181C26.4425 20.9081 26.7895 19.9881 26.9305 19.0001H28.9465C28.7815 20.4967 28.2415 21.9275 27.3765 23.1601ZM24.4665 20.2511L22.9185 18.7031C22.9725 18.4771 23.0015 18.2431 23.0015 18.0001V14.0001C23.0022 13.2948 22.7544 12.6118 22.3016 12.071C21.8488 11.5303 21.2199 11.1664 20.5255 11.0432C19.831 10.92 19.1154 11.0454 18.5042 11.3974C17.8931 11.7495 17.4255 12.3055 17.1835 12.9681L15.6875 11.4711C16.2426 10.5237 17.0942 9.78536 18.1107 9.37011C19.1271 8.95486 20.2521 8.88577 21.3117 9.17349C22.3714 9.46122 23.3069 10.0898 23.9738 10.9621C24.6406 11.8344 25.0018 12.902 25.0015 14.0001V18.0001C25.0027 18.7819 24.8198 19.553 24.4675 20.2511H24.4665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3554_11719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikeIcnCross);
export default __webpack_public_path__ + "static/media/mike-icn-cross.f8ddbb22aa8e1e41dbb3627ac6f0b44b.svg";
export { ForwardRef as ReactComponent };